import { Dropdown, Menu } from '@arco-design/web-react'
import { Check, Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { languageOptions, SupportedLanguage } from '@/i18n/language'
import { useLanguagePreference } from '@/hooks/useLanguagePreference'

const CONSOLE_TOPBAR_BTN = 'console-icon-btn'

interface LanguageSwitcherProps {
  variant?: 'console' | 'landing'
  className?: string
}

export default function LanguageSwitcher({ variant = 'console', className = '' }: LanguageSwitcherProps) {
  const { t } = useTranslation()
  const { currentLanguage, changeLanguage, loading } = useLanguagePreference()

  const buttonClass =
    variant === 'console'
      ? CONSOLE_TOPBAR_BTN
      : 'w-9 h-9 flex items-center justify-center rounded-lg border border-[var(--landing-border)] bg-white text-[var(--landing-text-muted)] hover:text-brand hover:border-[#C7D2FE] transition-colors'

  const iconSize = variant === 'console' ? 15 : 16

  return (
    <Dropdown
      position="br"
      trigger="click"
      droplist={
        <Menu
          className="language-switcher-menu !w-auto !min-w-0"
          onClickMenuItem={(key) => void changeLanguage(key as SupportedLanguage)}
          selectedKeys={[currentLanguage]}
        >
          {languageOptions.map((option) => {
            const selected = currentLanguage === option.value
            return (
              <Menu.Item key={option.value} disabled={loading}>
                <span className="inline-flex items-center gap-1.5 text-[13px]">
                  <span className={selected ? 'font-medium text-brand' : undefined}>{option.label}</span>
                  {selected ? <Check size={13} className="text-brand shrink-0" aria-hidden /> : null}
                </span>
              </Menu.Item>
            )
          })}
        </Menu>
      }
    >
      <button
        type="button"
        className={`${buttonClass} ${className}`}
        aria-label={t('common.changeLanguage')}
        disabled={loading}
      >
        <Languages size={iconSize} />
      </button>
    </Dropdown>
  )
}
